import { L } from 'ace-builds-internal/lib/bidiutil';

export const UNIT_GROUPS = [
    {
        value: 'infantry',
        label: 'Infantry',
        items: [
            { value: 'hq', label: 'Headquarters units' },
            { value: 'infantry', label: 'Infantry squads and teams' }
        ]
    },
    {
        value: 'artillery',
        label: 'Artillery',
        items: [
            { value: 'field_artillery', label: 'Field artillery' },
            { value: 'anti_tank_guns', label: 'Anti-Tank guns' },
            { value: 'anti_aircraft_guns', label: 'Anti-aircraft guns' }
        ]
    },
    {
        value: 'vehicles',
        label: 'Vehicles',
        items: [
            { value: 'tanks', label: 'Tanks' },
            { value: 'tank_destroyers', label: 'Tank destroyers' },
            { value: 'self_propelled_artillery', label: 'Self-propelled artillery' },
            { value: 'anti_aircraft_vehicles', label: 'Anti-aircraft vehicles' },
            { value: 'armoured_cars', label: 'Armoured cars' },
            { value: 'transports_and_tows', label: 'Transports and tows' },
            { value: 'ambulances', label: 'Ambulances' },
            { value: 'armoured_recovery_vehicles', label: 'Armoured Recovery Vehicles' },
            { value: 'armoured_recovery_vehicles', label: 'Armoured Recovery Vehicles' },

            // K47 only below
            { value: 'armoured_walkers', label: 'Armoured Walkers' },
            { value: 'assault_guns', label: 'Assault Guns' }
        ]
    }
];

export const UNIT_GROUP_ORDER = UNIT_GROUPS.reduce((agg, grp) => {
    // agg.push(grp.value);
    grp.items.forEach((item) => {
        agg.push(item.value);
    });
    return agg;
}, []);

export type UnitGroup = 'infantry' | 'artillery' | 'vehicles';
export type UnitType =
    | 'hq'
    | 'infantry'
    | 'field_artillery'
    | 'anti_tank_guns'
    | 'anti_aircraft_guns'
    | 'tanks'
    | 'tank_destroyers'
    | 'self_propelled_artillery'
    | 'anti_aircraft_vehicles'
    | 'armoured_cars'
    | 'transports_and_tows'
    | 'ambulances'
    | 'armoured_recovery_vehicles';
